import Alpine from 'alpinejs';
import Splide from '../../Helper/NeosSplide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';

/*
 * Wait till the page is fully loaded to minimize layout changes during page load.
 */
function startAutoScrollAfterLoad(splide) {
    const startAutoScroll = () => {
        window.setTimeout(() => {
            splide.Components.AutoScroll?.play();
        }, 1000);
    };

    if (document.readyState === 'complete') {
        startAutoScroll();
        return;
    }

    window.addEventListener('load', startAutoScroll, { once: true });
}

Alpine.data('logoslider', () => ({
    init() {
        const splide = new Splide(this.$root, {
            type: 'loop',
            drag: 'free',
            focus: 'center',
            arrows: false,
            pagination: false,
            mediaQuery: 'min',
            perMove: 1,
            inView: 'autoScroll',
            autoScroll: {
                speed: 0.75,
                autoStart: false,
                pauseOnHover: true,
            },
            breakpoints: {
                0: {
                    perPage: 2,
                },
                320: {
                    perPage: 3,
                },
                575: {
                    perPage: 4,
                },
                768: {
                    perPage: 5,
                },
                1024: {
                    perPage: 6,
                },
            },
        });

        splide.mount({ AutoScroll });
        startAutoScrollAfterLoad(splide);
    },
}));
